<template>
  <div class="inactive-screen vh-100">
    <div class="content text-center">
      <img
        class="brand-logo"
        src="@/assets/logo.svg"
        alt="Omroep West"
        width="300"
      />
      <!-- <h1>Speel mee met de grijpmachine</h1> -->
      <h1>Scan de QR-code <br />voor een <br />gratis spel</h1>
      <img
        :src="'https://clawmachine.nl/qrcode/?s=qr&sf=8&d=' + getUrl()"
        :title="getUrl()"
        width="320"
        class="qr"
      />
      <!-- <p class="note">Na het scannen verschijnt jouw naam op dit scherm.</p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "InactiveScreen",
  components: {},
  methods: {
    getUrl() {
      return process.env.VUE_APP_GAMEURL;
    },
  },
};
</script>

<style scoped>
.inactive-screen {
  background: #234d9d;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  padding: 48px 36px;
  width: min(900px, calc(100% - 32px));
  text-align: center;
}

h1 {
  font-size: 3.2rem;
  color: #ffffff;
  margin-bottom: 12px;
  font-weight: 700;
}
h2 {
  font-size: 1.8rem;
  color: #ffffff;
  margin-bottom: 24px;
}

.brand-logo {
  margin-bottom: 26px;
}

.qr {
  padding: 10px;
  margin-bottom: 16px;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;
}

.note {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.15rem;
}

@media (max-width: 1200px) {
  h1 {
    font-size: 2.4rem;
  }

  h2 {
    font-size: 1.4rem;
  }

  .content {
    padding: 32px 24px;
  }

  .qr {
    width: 260px;
  }
}

@media (min-height: 1920px) {
  h1 {
    font-size: 5.5rem;
    margin-bottom: 30px;
  }

  h2 {
    font-size: 2.8rem;
  }

  .brand-logo {
    width: 500px !important;
    margin-bottom: 50px;
  }

  .content {
    width: 90vw;
    padding: 80px 60px;
  }

  .qr {
    width: 520px;
    padding: 16px;
  }
}
</style>
